import { Flex } from "@radix-ui/themes";
import DateRangePicker, {
  DateRange,
} from "@/components/shared/date-range-picker-v2";
import { TabItem, Tabs } from "@/v2/components/tabs/Tabs";
import { Ticket03Icon } from "@/v2/assets/icons/Ticket03Icon";
import { Comment01Icon } from "@/v2/assets/icons/Comment01Icon";
import {
  ExploreInteractionType,
  exploreInteractionTypeToLabel,
} from "@/v2/entities/explore/Explore.model";

const sourceTabs: TabItem[] = [
  {
    value: "tickets",
    label: exploreInteractionTypeToLabel.tickets.plural,
    icon: <Ticket03Icon fill="blue" />,
  },
  {
    value: "conversations",
    label: exploreInteractionTypeToLabel.conversations.plural,
    icon: <Comment01Icon fill="orange" />,
  },
];

interface HomePageHeaderActionsProps {
  source: ExploreInteractionType;
  dateRange: DateRange;
  setSource: (source: ExploreInteractionType) => void;
  setDateRange: (dateRange: DateRange) => void;
}

export function HomePageHeaderActions({
  source,
  dateRange,
  setSource,
  setDateRange,
}: HomePageHeaderActionsProps) {
  const handleSourceChange = (value: string) => {
    if (value !== "tickets" && value !== "conversations") {
      return;
    }

    setSource(value);
  };

  return (
    <Flex gap="2">
      <DateRangePicker size="2" value={dateRange} onChange={setDateRange} />

      <Tabs
        variant="data"
        value={source}
        onValueChange={handleSourceChange}
        tabs={sourceTabs}
      />
    </Flex>
  );
}
